export default {
	version: 'fallback',
	min_length: 12,
	max_length: 128,
	require_uppercase: true,
	require_lowercase: true,
	require_digits: true,
	require_symbols: true,
	symbols: '!@#$%^&*()-_=+[]{};:,.<>/?',
	min_unique_chars: 6,
	forbid_user_attributes: true,
	forbid_compromised: true,
	history_size: 5,
	expiration_days: 90,
	expiration_warning_days: 7
}
